import batchServices from "./batchServices";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
  totalCount: 0,
  searchText: "",
  batchData: null,
  batchById: null
};

export const addBatch = createAsyncThunk(
  "batch/addBatch",
  async (params, thunkAPI) => {
    try {
      return await batchServices.addBatch(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getBatches = createAsyncThunk(
  "batch/getBatches",
  async (params, thunkAPI) => {
    try {
      return await batchServices.getBatches(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getBatchById = createAsyncThunk(
  "batch/getBatchById",
  async (params, thunkAPI) => {
    try {
      return await batchServices.getBatchById(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateBatchData = createAsyncThunk(
  "batch/updateBatchData",
  async (params, thunkAPI) => {
    try {
      return await batchServices.updateBatchData(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteBatchById = createAsyncThunk(
  "batch/deleteBatchById",
  async (params, thunkAPI) => {
    try {
      return await batchServices.deleteBatchById(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const batchSlice = createSlice({
  name: "batch",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addBatch.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addBatch.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(addBatch.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
      })
      .addCase(getBatches.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBatches.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getBatches.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
        state.totalCount = action.payload.data?.totalCount;
        state.batchData = action.payload.data?.result;
      })
      .addCase(getBatchById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBatchById.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getBatchById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
        state.batchById = action.payload.data;
      })
      .addCase(updateBatchData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateBatchData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(updateBatchData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
      })
      .addCase(deleteBatchById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteBatchById.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(deleteBatchById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
      })
  }
})

export const { } = batchSlice.actions;

export default batchSlice.reducer;
